import { IColumn } from '../../../store/modules/report/i-column';
import { IRecordMap } from '../../../store/modules/report/i-report';

// Map geometry keys that are NOT report columns but must stay selectable for the popup.
export const COORDINATE_POPUP_KEYS = ['X', 'Y', 'x', 'y'];

const recordKeySet = (recordsMap: Record<string, IRecordMap>): Set<string> => {
  const keys = new Set<string>();
  Object.values(recordsMap || {}).forEach((record) => {
    Object.keys(record).forEach((key) => {
      if (key !== 'uniqueKey') keys.add(key);
    });
  });
  return keys;
};

export const buildPopupFieldOptions = (
  columns: IColumn[] | undefined,
  recordsMap: Record<string, IRecordMap>,
  hasColumns: boolean,
): string[] => {
  const recordKeys = recordKeySet(recordsMap);
  if (!hasColumns || !columns || columns.length === 0) {
    return Array.from(recordKeys); // fallback: pre-load / aggregate reports
  }
  const named = [...columns]
    .sort((a, b) => a.order - b.order)
    .filter((col) => col.header && col.header !== 'uniqueKey');
  const headers = named.filter((col) => !col.hidden).map((col) => col.header);
  const seen = new Set(named.map((col) => col.header));
  const coords = COORDINATE_POPUP_KEYS.filter((key) => recordKeys.has(key) && !seen.has(key));
  return [...headers, ...coords];
};

export const reconcilePopupFields = (
  current: string[] | undefined,
  columns: IColumn[] | undefined,
  hasColumns: boolean,
): string[] | undefined => {
  if (!current) return current;
  if (!hasColumns || !columns || columns.length === 0) return current; // never prune against empty
  const hiddenHeaders = new Set(columns.filter((col) => col.hidden).map((col) => col.header));
  const valid = new Set<string>([
    ...columns.filter((col) => !col.hidden).map((col) => col.header),
    ...COORDINATE_POPUP_KEYS.filter((key) => !hiddenHeaders.has(key)),
  ]);
  const next = current.filter((key) => valid.has(key));
  return next.length === current.length ? current : next;
};
